import axiosInstance from '../auth/axiosConfig';
import {
  EVOLUCION_DASHBOARD_REQUEST,
  EVOLUCION_DASHBOARD_SUCCESS,
  EVOLUCION_DASHBOARD_FAIL,
} from './types';
import { Dispatch } from 'redux';


export const evolucionInventarioActions = (anioSeleccionado: number, mesSeleccionado: string, establ_corr: number) => async (dispatch: Dispatch): Promise<boolean> => {

  dispatch({ type: EVOLUCION_DASHBOARD_REQUEST });

  try {
    const res = await axiosInstance.get(`${import.meta.env.VITE_CSRF_API_URL}/evolucionInventarioActions?anioSeleccionado=${anioSeleccionado}&mesSeleccionado=${mesSeleccionado}&establ_corr=${establ_corr}`);

    if (res.status === 200) {
      if (res.data) {
        dispatch({
          type: EVOLUCION_DASHBOARD_SUCCESS,
          payload: res.data
        });
        return true;
      }

    } else {
      dispatch({ type: EVOLUCION_DASHBOARD_FAIL });
    }
    return false;
  } catch (err: any) {
    dispatch({
      type: EVOLUCION_DASHBOARD_FAIL,
      error: "Error en la solicitud:", err,
    });
    return false;
  }
};
